import { ShoppingCart, Package, Tag, Star, Settings } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';

const productos = [
  { id: 1, nombre: 'Libro: Oftalmología Clínica', precio: 15000, categoria: 'Libros', stock: true },
  { id: 2, nombre: 'Revista CAO - Suscripción Anual', precio: 8000, categoria: 'Suscripciones', stock: true },
  { id: 3, nombre: 'Kit Material Didáctico', precio: 5500, categoria: 'Educación', stock: true },
  { id: 4, nombre: 'Merchandising CAO', precio: 2500, categoria: 'Varios', stock: true },
];

const ECommerce = () => {
  return (
    <div className="space-y-6">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <Settings className="w-5 h-5 text-amber-600" />
          <div>
            <p className="font-medium text-amber-800">Módulo en configuración</p>
            <p className="text-sm text-amber-600">E-Commerce estará disponible próximamente. A continuación se muestra una vista previa.</p>
          </div>
        </div>
      </div>

      <div className="opacity-50 pointer-events-none select-none">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-500 mb-2">E-Commerce CAO</h1>
          <p className="text-gray-400">Tienda online de productos y servicios</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {productos.map((prod) => (
            <Card key={prod.id} className="bg-gray-50 border-gray-200">
              <div className="h-32 bg-gray-200 rounded-t-lg flex items-center justify-center">
                <Package className="w-12 h-12 text-gray-400" />
              </div>
              <CardContent className="p-4">
                <Badge className="mb-2 bg-gray-300 text-gray-600">{prod.categoria}</Badge>
                <h3 className="font-medium text-gray-500 mb-1">{prod.nombre}</h3>
                <p className="text-lg font-bold text-gray-500">${prod.precio.toLocaleString()}</p>
                <Button className="w-full mt-3 bg-gray-300 text-gray-500" disabled>
                  <ShoppingCart className="w-4 h-4 mr-2" /> Agregar
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ECommerce;
